import { images } from '.'; 
 
const projects = [  
    {
        id: 1,
        image: images.project1,
        title: 'Theme Garden',
        details: {
            date: 'February 2, 2024',
            client: 'GreenSpace Developers',
            category: 'garden design',
            duration: '3 weeks',
            area: 'Karachi, Pakistan',
            cost: '$2,800',
            designer: 'Botanical Design Studio',
        },
        paragraphs: [
            'A transformative urban garden project that reimagined outdoor living spaces through sustainable design principles. Our team combined native plant species with modern hardscaping to create an eco-friendly oasis in the heart of the city.',
            'The design focused on creating micro-climates through strategic plant placement, incorporating water-wise irrigation systems, and developing multi-functional outdoor areas for both recreation and urban wildlife support.',
        ],
        gallery: [   
            images.project1Gallery1,
            images.project1Gallery2,
            images.project1Gallery3,
            images.project1Gallery4,
            images.project1Gallery5,
            images.project1Gallery6,
        ],
        challenges: {
            intro: 'The urban site presented unique obstacles including limited space, poor soil quality, and client requirements for low-maintenance yet visually impactful garden solutions.',
            points: [
                'Inefficient plant zoning',
                'Limited biodiversity support',
                'Poor soil drainage system',
                'Lack of seasonal interest',
                'Inadequate outdoor lighting'
            ],
        },
        solutions: {
            intro: 'Our design team implemented a holistic approach combining permaculture principles with modern landscape architecture techniques.',
            points: [
                'Vertical gardening systems',
                'Native plant selection',
                'Smart irrigation installation',
                'Seasonal planting strategy',
                'Solar-powered landscape lighting'
            ],
        },
        results: {
            intro: 'The completed garden now serves as a model for urban sustainability, achieving 40% reduction in water usage while doubling local pollinator populations.',
            points: [
                'Custom garden layout planning',
                'Eco-system restoration design',
                'Outdoor living space integration',
                'Sustainable material selection',
                'Ongoing maintenance program'
            ],
        },
    }, 
    {
        id: 2,
        image: images.project2,
        title: 'Lawn Mowing',
        details: {
            date: 'March 15, 2024',
            client: 'GreenView Residences',
            category: 'Lawn Maintenance',
            duration: 'Ongoing service',
            area: 'Karachi, Pakistan',
            cost: '$150/month',
            designer: 'Professional Grounds Team',
        },
        paragraphs: [
            'Comprehensive lawn maintenance program transforming neglected outdoor spaces into pristine green landscapes. Our service includes regular mowing, edging, and lawn health monitoring for year-round curb appeal.',
            'Implemented a customized care schedule combining precision cutting techniques with seasonal fertilization to maintain optimal turf health and density.',
        ],
        gallery: [   
            images.project2Gallery1,
            images.project2Gallery2,
            images.project2Gallery3,
            images.project2Gallery4,
            images.project2Gallery5,
            images.project2Gallery6,
        ],
        challenges: {
            intro: 'The property faced multiple lawn care issues including uneven growth, weed infestation, and poor turf recovery after monsoon seasons.',
            points: [
                'Irregular mowing patterns',
                'Thinning turf areas',
                'Weed overgrowth',
                'Scalping from improper cutting',
                'Limited maintenance equipment'
            ],
        },
        solutions: {
            intro: 'Our certified team deployed professional-grade equipment and scientific lawn care methods:',
            points: [
                'Weekly maintenance schedule',
                'Pattern-alternation mowing',
                'Precision edging services',
                'Grasscycling (mulching clippings)',
                'Seasonal fertilizer application'
            ],
        },
        results: {
            intro: 'Achieved 95% weed reduction and improved turf density within 3 months, creating a lush uniform lawn that enhances property value.',
            points: [
                'Consistent lawn height maintenance',
                'Improved soil aeration',
                'Enhanced grass root development',
                'Reduced water requirements',
                'Year-round green coverage'
            ],
        },
    },
    {
        id: 3,
        image: images.project3,
        title: 'Landscape Design',
        details: {
            date: 'April 10, 2024',
            client: 'Urban Oasis Developers',
            category: 'Garden Design',
            duration: '6 weeks',
            area: 'Lahore, Pakistan',
            cost: '$8,500',
            designer: 'TerraForm Design Collective',
        },
        paragraphs: [
            'A comprehensive landscape architecture project transforming 1,200 sq.ft of urban space into a functional outdoor living environment. The design harmonizes hardscaping elements with native flora to create dynamic spatial relationships and year-round visual interest.',
            'Our approach integrated sustainable drainage solutions, ambient lighting systems, and multi-level planting schemes to maximize both aesthetic appeal and ecological functionality.',
        ],
        gallery: [   
            images.project3Gallery1,
            images.project3Gallery2,
            images.project3Gallery3,
            images.project3Gallery4,
            images.project3Gallery5,
            images.project3Gallery6,
        ],
        challenges: {
            intro: 'The site presented complex design constraints including uneven topography, limited sun exposure, and client requirements for low-maintenance yet high-impact visual design.',
            points: [
                'Poor site drainage',
                'Conflicting microclimates',
                'Limited privacy screening',
                'Inadequate outdoor living space',
                'Non-cohesive material palette'
            ],
        },
        solutions: {
            intro: 'Implemented cutting-edge landscape architecture strategies:',
            points: [
                '3D terrain modeling',
                'Permeable paving system',
                'Native xeriscaping zones',
                'Modular outdoor kitchen installation',
                'Smart irrigation integration'
            ],
        },
        results: {
            intro: 'The completed landscape increased property value by 25% while reducing maintenance costs by 35%, creating an award-winning outdoor environment featured in local design publications.',
            points: [
                'Custom water feature design',
                'Outdoor lighting master plan',
                'Drought-resistant planting scheme',
                'Entertainment zone development',
                'Seasonal color rotation system'
            ],
        },
    },
    {
        id: 4,
        image: images.project4,
        title: 'Patio Installation',
        details: {
            date: 'May 5, 2024',
            client: 'Hillview Residence',
            category: 'Hardscaping',
            duration: '4 weeks',
            area: 'Islamabad, Pakistan',
            cost: '$12,500',
            designer: 'Stonecraft Outdoor Living',
        },
        paragraphs: [
            'Complete transformation of a 600 sq.ft backyard into a luxurious outdoor living space featuring natural stone paving, integrated seating walls, and ambient lighting. The design focuses on creating seamless indoor-outdoor flow while ensuring year-round durability.',
            'Utilized premium materials including thermal-treated limestone and permeable jointing systems to combat seasonal weather challenges while maintaining aesthetic appeal.',
        ],
        gallery: [   
            images.project4Gallery1,
            images.project4Gallery2,
            images.project4Gallery3,
            images.project4Gallery4,
            images.project4Gallery5,
            images.project4Gallery6,
        ],
        challenges: {
            intro: 'The installation faced significant obstacles including sloping terrain, poor soil stability, and client requirements for low-maintenance luxury that complements existing architecture.',
            points: [
                'Uneven ground elevation',
                'Inadequate drainage planning',
                'Material expansion/contraction issues',
                'Limited access for machinery',
                'Integration with existing landscaping'
            ],
        },
        solutions: {
            intro: 'Implemented advanced hardscape engineering solutions:',
            points: [
                'Laser-guided grading system',
                'Compactable base aggregate layering',
                'Polymeric sand joint stabilization',
                'Custom drainage channel installation',
                'Modular stone seating integration'
            ],
        },
        results: {
            intro: 'The completed patio increased outdoor living space usage by 300% while achieving perfect drainage during monsoon tests, featured in Pakistan Home & Garden Magazine.',
            points: [
                'All-weather surface durability',
                'Custom fire pit integration',
                'Decorative edge restraint system',
                'Non-slip surface treatment',
                '5-year structural warranty'
            ],
        },
    },
    {
        id: 5,
        image: images.project5,
        title: 'Irrigation Management',
        details: {
            date: 'June 1, 2024',
            client: 'AgriGreen Farms',
            category: 'Lawn Maintenance',
            duration: '5 weeks',
            area: 'Punjab, Pakistan',
            cost: '$45,000',
            designer: 'HydroLogic Solutions',
        },
        paragraphs: [
            'Comprehensive irrigation overhaul implementing precision water management technology across 12-acre agricultural land. Integrated soil moisture sensors, weather forecasting APIs, and automated zone control to optimize water usage while maintaining crop health.',
            'The system features real-time monitoring through a centralized dashboard, enabling data-driven decisions that reduced water waste by 55% while increasing crop yield by 18%.',
        ],
        gallery: [   
            images.project5Gallery1,
            images.project5Gallery2,
            images.project5Gallery3,
            images.project5Gallery4,
            images.project5Gallery5,
            images.project5Gallery6,
        ],
        challenges: {
            intro: 'The existing irrigation system suffered from 40% water loss due to outdated equipment, uneven distribution, and lack of monitoring capabilities.',
            points: [
                'Overlapping spray patterns',
                'Inconsistent water pressure',
                'No moisture monitoring',
                'Daytime evaporation losses',
                'Manual valve operation'
            ],
        },
        solutions: {
            intro: 'Deployed advanced irrigation management technologies:',
            points: [
                'Smart weather-based controllers',
                'Pressure-compensated drip lines',
                'Soil moisture sensor network',
                'Zonal watering schedules',
                'Mobile control integration'
            ],
        },
        results: {
            intro: 'Achieved LEED-certified water efficiency standards with 1.3 million gallons annual water savings, while improving crop uniformity by 25%.',
            points: [
                'Real-time system analytics',
                'Fertigation integration',
                'Flow monitoring alerts',
                'Pressure-regulated emitters',
                '5-year maintenance contract'
            ],
        },
    }, 
    {
        id: 6,
        image: images.project6,
        title: 'Deck Building',
        details: {
            date: 'February 2, 2024',
            client: 'tech company',
            category: 'Hardscaping',
            duration: '1 month',
            area: 'karachi, pakistan',
            cost: '$1000',
            designer: 'joe root',
        },
        paragraphs: [
            'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Labore Repudiandae Aut Eum Rem Praesentium Doloremque Quos Perferendis Ipsa Sed Placeat Fugiat Minima Tenetur Facilis, Similique, Esse Molestias Harum. Illo, Obcaecati?',
            'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.',
        ],
        gallery: [   
            images.project6Gallery1,
            images.project6Gallery2,
            images.project6Gallery3,
            images.project6Gallery4,
            images.project6Gallery5,
            images.project6Gallery6,
        ],
        challenges: {
            intro: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.',
            points: [ 
                'Poor space utilisation',
                'Noisy open plan spaces',
                'No reflection spaces and quiet areas',
                'Lack of culture and community',
                'Not enough workspaces'
            ],
        },
        solutions: {
            intro: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.',
            points: [ 
                'Poor space utilisation',
                'Noisy open plan spaces',
                'No reflection spaces and quiet areas',
                'Lack of culture and community',
                'Not enough workspaces'
            ],
        },
        results: {
            intro: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Architecto, Vel Facere Iste Nobis Exercitationem Dicta? Sapiente Repellendus Quis In Sequi, Repellat, Maiores Architecto Debitis Reiciendis Odio Impedit Omnis Distinctio Ullam.',
            points: [ 
                'Workplace consultancy and space analysis',
                'Office layout and adjacency planning',
                'Dedicated sanctuary spaces'
            ],
        },
    },
    
];

export default projects;

